/**
 * Motorváltozatok márka + modell alapján (HU piac, tipikus EU motorok).
 * Pontos lista override-ban; ismeretlen modellnél kulcsszó-alapú szűkítés.
 */

const norm = (s) => (s || "").trim().toLowerCase();

const key = (make, model) => `${norm(make)}|${norm(model)}`;

const uniq = (arr) => [...new Set((arr || []).filter(Boolean))];

/** Márka|modell → motorok (elsődleges forrás) */
const OVERRIDES = {
  // Volkswagen
  [key("Volkswagen", "Polo")]: ["1.0 MPI", "1.0 TSI", "1.6 TDI"],
  [key("Volkswagen", "Golf")]: ["1.0 TSI", "1.4 TSI", "1.5 TSI", "2.0 TSI", "1.6 TDI", "2.0 TDI", "GTE", "e-Golf"],
  [key("Volkswagen", "Golf Variant")]: ["1.0 TSI", "1.5 TSI", "2.0 TSI", "1.6 TDI", "2.0 TDI", "GTE"],
  [key("Volkswagen", "Golf GTI")]: ["2.0 TSI", "2.0 TSI Performance"],
  [key("Volkswagen", "Golf R")]: ["2.0 TSI 4Motion"],
  [key("Volkswagen", "Passat")]: ["1.5 TSI", "2.0 TSI", "1.6 TDI", "2.0 TDI"],
  [key("Volkswagen", "Passat Variant")]: ["1.5 TSI", "2.0 TSI", "1.6 TDI", "2.0 TDI"],
  [key("Volkswagen", "Tiguan")]: ["1.5 TSI", "2.0 TSI", "2.0 TDI", "1.6 TDI", "Tiguan eHybrid"],
  [key("Volkswagen", "T-Roc")]: ["1.0 TSI", "1.5 TSI", "2.0 TSI", "1.6 TDI", "2.0 TDI"],
  [key("Volkswagen", "ID.3")]: ["Pro", "Pro S", "GTX"],
  [key("Volkswagen", "ID.4")]: ["Pure", "Pro", "GTX"],
  [key("Volkswagen", "ID.5")]: ["Pro", "GTX"],
  [key("Volkswagen", "Arteon")]: ["2.0 TSI", "2.0 TDI", "eHybrid"],
  [key("Volkswagen", "Touran")]: ["1.5 TSI", "2.0 TDI"],
  [key("Volkswagen", "Caddy")]: ["2.0 TDI", "1.5 TSI", "e-Caddy"],
  [key("Volkswagen", "Transporter")]: ["2.0 TDI", "2.0 BiTDI", "e-Transporter"],
  [key("Volkswagen", "Amarok")]: ["2.0 BiTDI", "3.0 V6 TDI"],

  // Škoda
  [key("Škoda", "Fabia")]: ["1.0 MPI", "1.0 TSI", "1.4 TDI"],
  [key("Škoda", "Octavia")]: ["1.0 TSI", "1.5 TSI", "2.0 TSI", "1.6 TDI", "2.0 TDI"],
  [key("Škoda", "Octavia Combi")]: ["1.0 TSI", "1.5 TSI", "2.0 TSI", "1.6 TDI", "2.0 TDI"],
  [key("Škoda", "Octavia RS")]: ["2.0 TSI", "2.0 TDI"],
  [key("Škoda", "Superb")]: ["1.5 TSI", "2.0 TSI", "2.0 TDI"],
  [key("Škoda", "Superb Combi")]: ["1.5 TSI", "2.0 TSI", "2.0 TDI"],
  [key("Škoda", "Kodiaq")]: ["1.5 TSI", "2.0 TSI", "2.0 TDI"],
  [key("Škoda", "Karoq")]: ["1.0 TSI", "1.5 TSI", "2.0 TDI"],
  [key("Škoda", "Kamiq")]: ["1.0 TSI", "1.5 TSI", "1.6 TDI"],
  [key("Škoda", "Enyaq")]: ["60", "80", "80x", "RS"],
  [key("Škoda", "Enyaq Coupé")]: ["60", "80", "80x", "RS"],

  // Audi
  [key("Audi", "A3")]: ["1.0 TFSI", "1.5 TFSI", "2.0 TFSI", "2.0 TDI", "1.6 TDI"],
  [key("Audi", "A4")]: ["2.0 TFSI", "2.0 TDI", "3.0 TDI", "35 TDI", "40 TFSI", "45 TFSI"],
  [key("Audi", "A6")]: ["2.0 TFSI", "2.0 TDI", "3.0 TDI", "45 TFSI", "50 TDI"],
  [key("Audi", "Q3")]: ["1.5 TFSI", "2.0 TFSI", "2.0 TDI", "35 TDI", "40 TFSI"],
  [key("Audi", "Q5")]: ["2.0 TFSI", "2.0 TDI", "3.0 TDI", "40 TDI", "45 TFSI", "50 TDI"],
  [key("Audi", "Q7")]: ["3.0 TDI", "3.0 TFSI", "45 TDI", "55 TFSI"],
  [key("Audi", "Q4 e-tron")]: ["35", "40", "50 quattro"],
  [key("Audi", "e-tron")]: ["50", "55", "S"],
  [key("Audi", "TT")]: ["2.0 TFSI", "2.0 TDI", "TTS", "TT RS"],

  // BMW
  [key("BMW", "3-as sorozat")]: ["318i", "320i", "320d", "330i", "330d", "330e", "M340i", "M340d"],
  [key("BMW", "5-ös sorozat")]: ["520i", "520d", "530i", "530d", "530e", "540i", "540d", "M550i"],
  [key("BMW", "X1")]: ["18i", "18d", "20i", "20d", "23d", "xDrive25e"],
  [key("BMW", "X3")]: ["20i", "20d", "30i", "30d", "M40i", "M40d"],
  [key("BMW", "X5")]: ["30d", "40i", "40d", "45e", "M50d", "M60i"],
  [key("BMW", "i4")]: ["eDrive35", "eDrive40", "M50"],
  [key("BMW", "iX3")]: ["eDrive"],
  [key("BMW", "iX")]: ["xDrive40", "xDrive50", "M60"],

  // Mercedes-Benz
  [key("Mercedes-Benz", "A-osztály")]: ["A180", "A200", "A220", "A250", "A180d", "A200d", "A250e"],
  [key("Mercedes-Benz", "C-osztály")]: ["C180", "C200", "C220d", "C300", "C300de", "C300e", "AMG C43"],
  [key("Mercedes-Benz", "E-osztály")]: ["E200", "E220d", "E300", "E300de", "E300e", "E400d", "AMG E53"],
  [key("Mercedes-Benz", "GLC")]: ["GLC200", "GLC220d", "GLC300", "GLC300de", "GLC300e", "AMG GLC43"],
  [key("Mercedes-Benz", "GLE")]: ["GLE300d", "GLE350de", "GLE400d", "GLE450", "AMG GLE53"],
  [key("Mercedes-Benz", "EQA")]: ["250", "250+", "350"],
  [key("Mercedes-Benz", "EQC")]: ["400"],
  [key("Mercedes-Benz", "EQE")]: ["300", "350", "350+", "500", "53 AMG"],

  // Toyota
  [key("Toyota", "Yaris")]: ["1.0 VVT-i", "1.5 Hybrid", "GR Sport"],
  [key("Toyota", "Corolla")]: ["1.8 Hybrid", "2.0 Hybrid", "1.6", "2.0"],
  [key("Toyota", "Corolla Touring Sports")]: ["1.8 Hybrid", "2.0 Hybrid"],
  [key("Toyota", "RAV4")]: ["2.0", "2.5 Hybrid", "2.5 PHEV"],
  [key("Toyota", "C-HR")]: ["1.8 Hybrid", "2.0 Hybrid", "1.2 Turbo"],
  [key("Toyota", "Prius")]: ["1.8 Hybrid", "2.0 PHEV"],
  [key("Toyota", "Land Cruiser")]: ["2.8 D-4D", "3.3 V6 Twin Turbo Diesel"],
  [key("Toyota", "bZ4X")]: ["FWD", "AWD"],

  // Ford
  [key("Ford", "Fiesta")]: ["1.0 EcoBoost", "1.1 Ti-VCT", "1.5 TDCi"],
  [key("Ford", "Focus")]: ["1.0 EcoBoost", "1.5 EcoBoost", "1.5 TDCi", "2.0 TDCi"],
  [key("Ford", "Kuga")]: ["1.5 EcoBoost", "2.0 EcoBlue", "2.5 PHEV"],
  [key("Ford", "Puma")]: ["1.0 EcoBoost", "1.0 EcoBoost MHEV"],
  [key("Ford", "Mustang Mach-E")]: ["Standard Range", "Extended Range", "GT"],

  // Opel / Renault / Peugeot (minták)
  [key("Opel", "Corsa")]: ["1.2", "1.2 Turbo", "1.5 Diesel", "Electric"],
  [key("Opel", "Astra")]: ["1.2 Turbo", "1.5 Diesel", "1.6 Turbo", "PHEV"],
  [key("Renault", "Clio")]: ["1.0 SCe", "1.0 TCe", "1.5 dCi", "E-Tech Hybrid"],
  [key("Renault", "Megane")]: ["1.3 TCe", "1.5 dCi", "E-Tech Hybrid"],
  [key("Renault", "Captur")]: ["1.0 TCe", "1.3 TCe", "1.5 dCi", "E-Tech Hybrid", "E-Tech PHEV"],
  [key("Peugeot", "208")]: ["1.2 PureTech", "1.5 BlueHDi", "e-208"],
  [key("Peugeot", "308")]: ["1.2 PureTech", "1.5 BlueHDi", "1.6 PureTech", "PHEV"],
  [key("Peugeot", "3008")]: ["1.2 PureTech", "1.5 BlueHDi", "1.6 PureTech", "Hybrid", "PHEV"],

  // Hyundai/Kia nincs a katalógusban — japán
  [key("Honda", "Civic")]: ["1.0 VTEC Turbo", "1.5 VTEC Turbo", "2.0 e:HEV", "Type R 2.0 Turbo"],
  [key("Honda", "CR-V")]: ["2.0 i-MMD Hybrid", "1.5 VTEC Turbo", "2.2 i-DTEC"],
  [key("Nissan", "Qashqai")]: ["1.3 DIG-T", "1.5 dCi", "e-POWER"],
  [key("Nissan", "Leaf")]: ["40 kWh", "62 kWh"],
  [key("Mazda", "Mazda3")]: ["2.0 Skyactiv-G", "2.0 Skyactiv-X", "1.8 Skyactiv-D"],
  [key("Mazda", "CX-5")]: ["2.0 Skyactiv-G", "2.5 Skyactiv-G", "2.2 Skyactiv-D"],
  [key("Volvo", "XC60")]: ["B4", "B5", "B6", "D4", "D5", "T6", "T8 Recharge"],
  [key("Volvo", "XC90")]: ["B5", "B6", "D5", "T8 Recharge"],
  [key("Porsche", "Cayenne")]: ["3.0 V6", "3.0 V6 Diesel", "E-Hybrid", "Turbo", "Turbo S"],
  [key("Porsche", "Macan")]: ["2.0 T", "2.0 T Diesel", "S", "GTS", "Turbo"],
  [key("Porsche", "911")]: ["Carrera", "Carrera S", "GTS", "Turbo", "Turbo S"],
};

const EV_PATTERN = /\b(e-tron|eq[a-z]?|id\.|i[x4|5|7]|ix\d|e-\d|electric|elektromos|ev\b|zoe|leaf|bolt|born|enyaq|taycan|mach-e|bz4x|model 3|model y|ioniq|kona electric|e-208|e-2008|e-c4|spring|dacia spring)/i;
const PHEV_PATTERN = /\b(phev|plug-in|plugin|ehybrid|e-hybrid|gte|iperformance|t8|outlander phev|kuga phev|passat gte)/i;
const HYBRID_PATTERN = /\b(hybrid|e-tech|mhev|phev|e:hev|e-hev|e-power|hibrid)/i;
const DIESEL_PATTERN = /\b(tdi|tdci|dci|cdti|bluehdi|hdi|d-4d|ecoblue|skyactiv-d|d\d{3}| \d\.\d d|diesel|dízel)/i;
const PETROL_PATTERN = /\b(tsi|tfsi|tce|puretech|ecoboost|vtec|skyactiv-g|benzin|petrol|mpi|t-gdi)/i;

const GENERIC = {
  ev: ["Elektromos", "Standard Range", "Long Range", "AWD"],
  phev: ["Plug-in hibrid", "1.4 TSI PHEV", "2.0 PHEV", "T8 Recharge"],
  hybrid: ["Hibrid", "1.8 Hybrid", "2.0 Hybrid", "2.5 Hybrid", "e-POWER"],
  diesel: ["1.5 TDI", "1.6 TDI", "2.0 TDI", "2.0 D", "3.0 D"],
  petrol: ["1.0 T", "1.2 T", "1.4 T", "1.5 T", "2.0 T", "2.0 Turbo"],
  default: ["1.0 T", "1.2 T", "1.4 T", "1.5 T", "1.6 D", "2.0 T", "2.0 D", "2.0 Turbo", "Elektromos", "Hibrid"],
};

/** Márka szint — ha a modell nincs külön listázva, ezekből választható */
const MAKE_PROFILES = {
  volkswagen: ["1.0 MPI", "1.0 TSI", "1.4 TSI", "1.5 TSI", "2.0 TSI", "1.6 TDI", "2.0 TDI", "GTE", "Elektromos"],
  škoda: ["1.0 TSI", "1.5 TSI", "2.0 TSI", "1.6 TDI", "2.0 TDI", "RS", "Elektromos"],
  skoda: ["1.0 TSI", "1.5 TSI", "2.0 TSI", "1.6 TDI", "2.0 TDI", "RS", "Elektromos"],
  seat: ["1.0 TSI", "1.5 TSI", "2.0 TSI", "1.6 TDI", "2.0 TDI"],
  cupra: ["1.5 TSI", "2.0 TSI", "2.0 TDI", "PHEV", "Elektromos"],
  audi: ["1.0 TFSI", "1.5 TFSI", "2.0 TFSI", "2.0 TDI", "3.0 TDI", "35 TDI", "40 TFSI", "45 TFSI", "50 TDI", "e-tron"],
  bmw: ["318i", "320i", "320d", "330i", "330d", "330e", "520i", "520d", "530i", "530d", "xDrive30d", "Elektromos"],
  "mercedes-benz": ["A180", "A200", "A220d", "C200", "C220d", "C300", "E220d", "E300", "320d", "Elektromos", "EQA", "EQC"],
  opel: ["1.2", "1.2 Turbo", "1.5 Diesel", "1.6 Turbo", "Elektromos"],
  ford: ["1.0 EcoBoost", "1.5 EcoBoost", "1.5 TDCi", "2.0 TDCi", "2.5 PHEV", "Elektromos"],
  renault: ["1.0 SCe", "1.0 TCe", "1.3 TCe", "1.5 dCi", "E-Tech Hybrid", "E-Tech PHEV", "Elektromos"],
  peugeot: ["1.2 PureTech", "1.5 BlueHDi", "1.6 PureTech", "Hybrid", "PHEV", "Elektromos"],
  citroën: ["1.2 PureTech", "1.5 BlueHDi", "Hybrid", "Elektromos"],
  "ds automobiles": ["1.2 PureTech", "1.5 BlueHDi", "PHEV", "Elektromos"],
  toyota: ["1.0 VVT-i", "1.5 Hybrid", "1.8 Hybrid", "2.0 Hybrid", "2.5 Hybrid", "2.5 PHEV", "2.0 D-4D", "Elektromos"],
  honda: ["1.0 VTEC Turbo", "1.5 VTEC Turbo", "2.0 e:HEV", "2.2 i-DTEC", "Elektromos"],
  nissan: ["1.0", "1.3 DIG-T", "1.5 dCi", "e-POWER", "Elektromos"],
  mazda: ["2.0 Skyactiv-G", "2.0 Skyactiv-X", "2.5 Skyactiv-G", "1.8 Skyactiv-D", "2.2 Skyactiv-D"],
  hyundai: ["1.0 T-GDI", "1.5 T-GDI", "1.6 CRDi", "2.0 CRDi", "Hibrid", "Elektromos"],
  kia: ["1.0 T-GDI", "1.4 T-GDI", "1.6 CRDi", "1.6 T-GDI", "Hibrid", "Elektromos"],
  volvo: ["B4", "B5", "B6", "D4", "D5", "T6", "T8 Recharge", "Elektromos"],
  porsche: ["2.0 T", "2.0 T Diesel", "3.0 V6", "3.0 V6 Diesel", "E-Hybrid", "Turbo", "Turbo S"],
  fiat: ["1.0 FireFly", "1.2", "1.3 MultiJet", "1.4 T-Jet", "Elektromos"],
  "alfa romeo": ["1.4 T", "2.0 Turbo", "2.2 JTD", "1.6 JTD", "PHEV"],
  dacia: ["1.0 SCe", "1.0 TCe", "1.5 dCi", "Elektromos"],
  suzuki: ["1.0 Boosterjet", "1.2 Dualjet", "1.4 Boosterjet", "1.6", "Hibrid"],
  mitsubishi: ["1.2", "1.6", "2.0", "2.4 PHEV", "2.2 DI-D", "Elektromos"],
  subaru: ["2.0i", "2.5i", "2.0 e-Boxer", "2.5 e-Boxer", "2.0 Turbo"],
  lexus: ["2.0 Turbo", "2.5 Hybrid", "3.5 V6", "PHEV", "Elektromos"],
  "land rover": ["2.0 P250", "2.0 D200", "3.0 D300", "3.0 P400", "PHEV"],
  jaguar: ["2.0 P250", "2.0 D200", "3.0 D300", "PHEV", "Elektromos"],
  mini: ["One", "Cooper", "Cooper S", "Cooper SE", "D", "SD"],
  smart: ["EQ", "1.0", "Elektromos"],
};

function resolveOverride(make, model) {
  const exact = OVERRIDES[key(make, model)];
  if (exact?.length) return exact;

  const first = (model || "").trim().split(/\s+/)[0];
  if (first && first !== model) {
    const base = OVERRIDES[key(make, first)];
    if (base?.length) return base;
  }

  const m = model || "";
  if (EV_PATTERN.test(m)) return GENERIC.ev;
  if (PHEV_PATTERN.test(m)) return GENERIC.phev;
  if (HYBRID_PATTERN.test(m)) return GENERIC.hybrid;
  if (DIESEL_PATTERN.test(m)) return GENERIC.diesel;
  if (PETROL_PATTERN.test(m)) return GENERIC.petrol;

  const byMake = MAKE_PROFILES[norm(make)];
  if (byMake?.length) return byMake;

  return GENERIC.default;
}

/** Nyilvános API — márka + modell kötelező */
export function enginesForMakeModel(make, model) {
  if (!make?.trim() || !model?.trim()) return [];
  const list = resolveOverride(make.trim(), model.trim());
  return uniq(list);
}
